module.exports = new __parcel__URL__("customer.706ba1f6.html").toString();